import { useValidationStepData } from '../../validationStepContext/useValidationStepData/useValidationStepData'

import { useServices } from '@percent/product-nomination-form/hooks'
import { useQuery } from '@percent/utility'
import { RegisterOrganisation } from './RegisterOrganisation'

export const RegisterOrganisationContainer = () => {
  const { country } = useValidationStepData()
  const { registriesService } = useServices()

  const { data, error, isLoading, refetch } = useQuery(
    [`v1/registries`, country],
    registriesService.getRegistries,
    {
      countryCode: country,
    },
    {
      retry: false,
      enabled: !!country,
    }
  )

  return (
    <RegisterOrganisation
      refetchRegistries={refetch}
      isError={!!error}
      isLoading={isLoading}
      registries={data}
    />
  )
}
